// extracted by mini-css-extract-plugin
module.exports =  {"slider":"bonus_slider-module_slider_b4f4f","icon":"bonus_slider-module_icon_dc4aa"};